export default __webpack_public_path__ + "static/media/blizzard-logo-for-dark-background.b1eeaaaa.png";